import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";


import { FaRegEdit, FaRegTrashAlt, FaPlus, FaSearch } from "react-icons/fa";
import { API_URL } from "../../../../api";
import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Tooltip,
  TextField,
  InputAdornment,
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Chip,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

const PurchaseDiscountRule = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [stampPrograms, setStampPrograms] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleDelete = (id) => {
    api
      .delete("stamp-programs/" + id)
      .then(() => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        getStampPrograms();
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error?.response?.data?.message || "Error deleting promotion",
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const confirmDelete = (id) => {
    Swal.fire({
      title: "Delete Confirmation",
      text: "Are you sure to delete this promotion?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, Cancel",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id);
      }
    });
  };

  const getStampPrograms = async () => {
    setIsLoading(true);
    try {
      const res = await api.get("stamp-programs", {
        params: {
          page: page + 1,
          limit: rowsPerPage,
          search: searchTerm,
        },
      });
      const dataList = res.data?.data || [];
      setStampPrograms(dataList);
      setTotalCount(res.data?._metadata?.total || dataList.length);
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getStampPrograms();
    }, 300);
    return () => clearTimeout(delayDebounceFn);
  }, [page, rowsPerPage, searchTerm]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getRewardColor = (rewardType) => {
    switch (rewardType) {
      case "Amount": return "primary";
      case "Percentage": return "secondary";
      case "FOCItem": return "success";
      default: return "default";
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleDateString();
  };

  return (
    <div className="App">
      <div className="wrapper">
        <div className="content-header pb-2">
          <div className="container-fluid px-3 d-flex justify-content-between">
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{ color: "#333", display: "flex", alignItems: "center", gap: 1 }}
            >
              Purchase Discount Rules Management
            </Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                {/* <Link to="/purchase-histories">
                  <Button
                    variant="outlined"
                    color="info"
                    sx={{ borderRadius: "8px", textTransform: "none", px: 3 }}
                  >
                    Purchase Histories
                  </Button>
                </Link> */}
                <Link to="/purchase-discount/create">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<FaPlus />}
                    sx={{ borderRadius: "8px", textTransform: "none", px: 3 }}
                  >
                    Create Purchase Discount Rule
                  </Button>
                </Link>
              </Box>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid px-3">
            <Card sx={{ mb: 4, borderRadius: 2, boxShadow: 3 }}>
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                    flexWrap: "wrap",
                    gap: 2,
                  }}
                >
                  <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Search by name..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setPage(0);
                    }}
                    sx={{ width: { xs: "100%", sm: "300px" } }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <FaSearch color="action" />
                        </InputAdornment>
                      ),
                    }}
                  />
                  
                </Box>

                <TableContainer component={Paper} elevation={0} sx={{ border: "1px solid #e0e0e0" }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow
                        sx={{ "& th": { backgroundColor: "#f5f5f5", color: "#333", fontWeight: "bold" } }}
                      >
                        <TableCell>#</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Earn Type</TableCell>
                        <TableCell>Earn Value</TableCell>
                        <TableCell>Stamps Required</TableCell>
                        <TableCell>Reward Type</TableCell>
                        <TableCell>Reward Value</TableCell>
                        <TableCell>Start Date</TableCell>
                        <TableCell>End Date</TableCell>
                        <TableCell align="center">Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {isLoading ? (
                        <TableRow>
                          <TableCell colSpan={10} sx={{ textAlign: "center", py: 5 }}>
                            <CircularProgress />
                          </TableCell>
                        </TableRow>
                      ) : stampPrograms.length > 0 ? (
                        stampPrograms.map((rule, i) => {
                          const focName = rule.focItem
                            ? rule.focItemModel === "Treatments"
                              ? (typeof rule.focItem.name === "string" ? rule.focItem.name : rule.focItem.treatmentName?.name || "")
                              : (typeof rule.focItem.medicineItemName === "string" ? rule.focItem.medicineItemName : "")
                            : "";
                          const rewardLabel =
                            rule.rewardType === "FOCItem"
                              ? `FOC (${focName || "-"})`
                              : rule.rewardType === "Percentage"
                              ? `${rule.rewardValue ?? "-"}%`
                              : rule.rewardType === "Amount"
                              ? `${rule.rewardValue ?? "-"}`
                              : rule.rewardType || "-";

                          return (
                            <TableRow key={rule._id || i} hover>
                              <TableCell>{page * rowsPerPage + i + 1}</TableCell>
                              <TableCell>{rule.name || "-"}</TableCell>
                              <TableCell>
                                <Chip
                                  label={rule.earnType || "-"}
                                  color="info"
                                  size="small"
                                  variant="outlined"
                                />
                              </TableCell>
                              <TableCell>{rule.earnValue ?? "-"}</TableCell>
                              <TableCell>{rule.totalStampsRequired ?? "-"}</TableCell>
                              <TableCell>
                                <Chip
                                  label={rule.rewardType || "-"}
                                  color={getRewardColor(rule.rewardType)}
                                  size="small"
                                  variant="outlined"
                                />
                              </TableCell>
                              <TableCell>{rewardLabel}</TableCell>
                              <TableCell>{formatDate(rule.startDate)}</TableCell>
                              <TableCell>{formatDate(rule.endDate)}</TableCell>
                              <TableCell align="center">
                                <Tooltip title="Edit">
                                  <IconButton
                                    color="primary"
                                    onClick={() => navigate("/purchase-discount/edit/" + rule._id)}
                                    size="small"
                                  >
                                    <FaRegEdit />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete">
                                  <IconButton
                                    color="error"
                                    onClick={() => confirmDelete(rule._id)}
                                    size="small"
                                  >
                                    <FaRegTrashAlt />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={10}
                            sx={{ textAlign: "center", py: 5, color: "text.secondary" }}
                          >
                            No purchase discount rules found.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{ "& p": { marginBottom: 0 } }}
                  />
                </TableContainer>
              </CardContent>
            </Card>

          </div>
        </section>
      </div>
    </div>
  );
};

export default PurchaseDiscountRule;
